import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DialogModule, TreeModule } from 'primeng/primeng';
import { MenuModule } from 'primeng/primeng';
import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { ConfirmResetComponent } from './confirm-reset/confirm-reset.component';
import { AuthHeaderComponent } from './auth-header/auth-header.component';
import { AppErrorMsgModule } from '../app-error-msg/app-error-msg.module';
import { SelectInstitutionComponent } from './select-institution/select-institution.component';
import { FooterEproveLinksComponent } from './footer-eprove-links/footer-eprove-links.component';
import { AuthGuardService } from './services/auth-guard.service';
import { CustomerResolveService } from './services/customer-resolve.service';
import { CustomerService } from './services/customer.service';
import { TokenService } from './services/token.service';
import { ValidationService } from './services/validation.service';
import { UserService } from './services/user.service';
import { AuthService } from './services/auth.service';
import { ResetPasswordGuardService } from './services/reset-password-guard.service';
import { ExpiredLinkComponent } from './expired-link/expired-link.component';
import { StrongPipe } from './strong.pipe';
import { InstitutionService } from './services/institution.service';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MenuModule,
    TreeModule,
    AppErrorMsgModule
  ],
  declarations: [
    LoginComponent,
    ResetComponent,
    AuthHeaderComponent,
    SelectInstitutionComponent,
    ConfirmResetComponent,
    FooterEproveLinksComponent,
    ExpiredLinkComponent,
    StrongPipe
  ],
  providers: [
    AuthGuardService,
    CustomerResolveService,
    ResetPasswordGuardService,
    CustomerService,
    TokenService,
    AuthService,
    ValidationService,
    UserService,
    InstitutionService
  ]
})

export class AuthModule { }
